// src/app/lib/validation/authValidation.ts
import { z } from "zod";

export const loginSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, "Email is required")
    .email("Enter a valid email address"),
  password: z
    .string()
    .trim()
    .min(1, "Password is required"),
});

export type LoginFormValues = z.infer<typeof loginSchema>;